import type { FulfillmentOrderDisplayStatusRoot } from '@repo/sdk'

export const DISPLAY_STATUSES: FulfillmentOrderDisplayStatusRoot[] = [
  'PAYMENT_PENDING',
  'PAID',
  'SHIPPED',
  'DELIVERED',
  'CONFIRMED',
  'ALL_CANCELLED',
]

const DISPLAY_STATUS_SET: ReadonlySet<string> = new Set<FulfillmentOrderDisplayStatusRoot>(
  DISPLAY_STATUSES,
)

export function isDisplayStatus(value: string): value is FulfillmentOrderDisplayStatusRoot {
  return DISPLAY_STATUS_SET.has(value)
}
